// 按页面划分
export default {
    // 公共页面
    common: {
        title: "Centre commercial de données",
        pull_refresh: 'Déroulez pour actualiser',
        release_refresh: 'Relâchez pour actualiser',
        refresh_loading: 'Chargement…',
        footer_text: 'Services fournis par Ucloudlink (NASDAQ: UCL)'
    },
    home: {
        input_placeholder: 'Rechercher un pays/une région',
        my_flow: 'Mes données',
        charge_code: 'Code de réduction',
        coupons:'Coupons',
        local_package: 'Données locales',
        more: 'Plus',
        popular_destination: 'Pays/région',
        buy_now: 'Acheter maintenant',
        package_useing: 'Actif',
        unused: 'Inactif',
        download_app: 'Télécharger l\'application',
        enter_the_mall_list: 'Entrer dans la liste du centre commercial',
        no_data: 'Pas encore de données',
        no_data_available: 'Aucune donnée disponible',
        copy_success: 'Copie réussie',
        copy_fail: 'Échec de la copie',
        meritsTitle: 'Quels sont les avantages?',
        merits1: 'Pas de SIM requis & Pas de frais mensuels',
        merits2: 'Intégré aux 2-3 meilleurs opérateurs pour la commutation réseau automatique',
        go_buy: 'Acheter maintenant',
        instant_savings: 'Économiser',
        expires_in: 'Expire dans',
        download_app_tips: "Téléchargez l’app pour plus d’offres et d’expériences"
    },
    packages: {
        sub_title: {
            us: 'Hors Guam, Saipan',
            it: 'Y compris la Cité du Vatican et Saint-Marin',
            va: "Y compris l'Italie, Saint-Marin",
            sm: "Y compris l'Italie, la Cité du Vatican",
            ma: 'Y compris le Sahara occidental',
            eh: 'Y compris le Maroc',
            ch: 'Y compris le Liechtenstein',
            li: 'Y compris la Suisse',
            fr: 'Y compris Monaco',
            mc: 'Y compris la France',
            fi: 'Y compris les îles Aland',
            ax: 'Y compris la Finlande',
            gu: 'Y compris les îles Mariannes du Nord',
            mp: 'Y compris Guam'
        },
        unlimited_packages: 'Forfait de données illimité',
        normal_packages: 'Paquet de données normal',
        multi_region_packages: 'Multi-région',
        regional_data: 'Données Régionales',
        high_speed_text: 'données à grande vitesse',
        infiniteFlow: 'Données illimitées',
        unLimitData: 'Illimité',
        high_speed_text_year: 'haute vitesse/mp',
        package_list: 'Liste des forfaits',
        special_offer: 'Soldes',
        first_month: '1er Mois',
        periodUnit: {
            day: 'jours)',
            month: 'mois',
            hour: 'heures)',
            year: 'année',
        },
        periodUnits: {
            day: 'jours)',
            month: 'mois',
            hour: 'heures)',
            year: 'années',
        },
        periodUnitSimp: {
            day: 'd',
            month: 'pour',
            hour: 'h',
            year: 'le'
        },
        periodUnitMonthly:'Mensuel',
        periodUnitsSimp: {
            day: 'd',
            month: 'pour',
            hour: 'h',
            year: 'le'
        },
        unlimited_good_name: {
            day: 'Pass journalier',
            month: 'Pass mensuel',
            year: 'Pass annuel'
        },
        continuousMonth: "Mois continus",
        continuousDay: "Jours continus",
        continuousYear: "Années continues",

        day_invalid: 'Expire le jour en cours',
        month_invalid: 'Expire dans le mois en cours',
        immediate_valid: 'En vigueur immédiatement',
        tomorrow_day_valid: 'En vigueur dès le lendemain',
        tomorrow_month_valid: 'En vigueur à partir du mois prochain',

        // detail page
        detail: {
            cell_flow: 'Données',
            cell_period: 'Validité',
            buy_quantity: 'Montant',
            use_area: 'Couverture',
            use_intro: 'Termes et conditions',
            buy_btn: 'Commande',
            pay: "Payer",
            buy_tips: "Vous avez le forfait %@packageName en cours d'utilisation. Voulez-vous acheter ce forfait?",
            haveOrderTips: "Commande en attente de paiement générée. Cliquez Confirmer pour accéder à ma page de données！"
        },

        // confirm page
        confirm: {
            title: 'Confirmation de commande',
            real_pay_amount: 'Montant payé',
            online_payment: 'Paiement en ligne',
            create_order_error: "Échec de l'installation"
        }
    },
    pay: {
        // result page
        result: {
            loading_order_status: 'Obtenir le statut de la commande…',
            buy_success: 'Commande terminée',
            buy_pending: 'En attente de confirmation',
            buy_pending_tip: "Paiement en cours… Si le paiement n'a pas été transféré dans les 10 minutes, veuillez nous contacter pour obtenir de l'aide.",
            get_payment_info_fail: "Échec de l'acquisition des informations de paiement",
            cell_package: 'Emballer',
            cell_buy_amount: 'Total',
            cell_real_amount: 'Montant payé',
            go_to_order_btn: 'Aller à Mon Forfait',
            back_home: 'Retour à la maison',
            back_mall: 'Retour au centre commercial',
            ordersn_empty: 'Le SN de la commande ne peut pas être vide',
            order_search_error: 'Erreur inattendue',
            goodsName:'Nom de produit'
        },

        //fail page
        fail: {
            payment_fail: 'Échec du paiement',
            back_home: 'Retour à la maison'
        }
    },
    CountryGroup: {
        title: "Pays/région",
        placeholder: "Rechercher un pays ou une région",
        clear: "Clair",
        history: "Historique de recherche"
    },
    PromotionCode: {
        verification: {
          title: 'Code de réduction',
          minititle:'Code de réduction',
          input: 'Veuillez entrer le code de recharge',
          explain: 'Conseils : appuyez sur le bouton de numérisation en haut à droite pour scanner le code QR de la carte du bon d\'achat, ou saisissez manuellement le code du bon d\'achat (sensible à la casse) s\'il ne fonctionne pas.',
          submit: 'Soumettre',
          exchange: 'Racheter',
          cancel: 'Annuler',
          Inquiry: "Etes-vous sûr d'échanger",
          ErrorCode: 'Erreur de code de recharge',
        },
        recharge_success: {
          package: 'Emballer',
          content: 'Récupéré avec succès',
          back: 'Retour au centre commercial',
          view_packets: 'Aller à Mon Forfait'
        }
      },
      order: {
        state: {
          inUse: 'Activé',
          isFirst: 'Priorisé',
          toFirst: 'Définir la priorité',
          inactive: 'Inactivé'
        },
        periodUnits: {
          minute: 'minutes)',
          hour: 'heures)',
          day: 'jours)',
          month: 'mois',
        },
        useIntro: {
          tip1: 'Le forfait de données illimité a une priorité plus élevée que le forfait de données en volume；',
          tip2: 'La priorité d\'utilisation sera basée sur la date d\'achat pour le même type de forfait, c\'est-à-dire que le forfait avec la date d\'achat la plus ancienne sera utilisé en premier, tandis que la priorité des forfaits monorégionaux est supérieure à celle du forfait régional；',
          tip3: 'Vous pouvez également ajuster manuellement la priorité d\'utilisation des paquets du même type.'
        },
        myFlow: 'Mes données',
        remainingFlow: 'Données restantes',
        remainingTime: 'Valide à gauche',
        remainingHighFlow: 'Données à haut débit restantes',
        validPeriod: 'Validité',
        noneFlow: 'Pas de paquet de données',
        noneFlowTip: 'Veuillez acheter le forfait de données et profiter d\'un réseau de haute qualité',
        buyPackFlow: 'Acheter des packs',
        checkInvalidFlow: 'Vérifier le paquet de données expiré',
        orderList:   {
          "title": "mes commandes",
          "amount_paid": "Total",
          "device": "Appareil possédé",
          "order_details": "Détails de la commande",
          "total_amont": "Total",
          "orderSN": "N° de commande",
          "createTime": "Temps de création",
          "cancelTime": "Heure de fermeture",
          "payTime": "Heure de commande",
          "unsubTime": "Heure annulée",
          "payMethod": "Mode de paiement",
          "thirdSN": "Numéro de transaction",
          "delete": "Supprimer",
          "cancel": "Annuler la commande",
          "unsub": "Remboursement",
          "goto_cancel": "Voulez-vous annuler la commande?",
          "goto_unsubscribe": "Voulez-vous annuler la commande?",
          "delete_Tips": "La commande ne peut pas être reprise après avoir été supprimée, vos problèmes après-service ne peuvent donc pas être traités.Êtes-vous sûr de le supprimer ?",
          "status_success": "Complété",
          "status_pending": "Non rémunéré",
          "status_cancel": "Fermé",
          "status_unsub": "Annulé",
          "payMethod_stripe": "Carte de crédit"
        },
      },
      registerlogin: { 
        create_account_tip:"Geräte verwenden Land/Region",
        select_country_tip:"Appareil utilise le pays / la région",
        email_name: "Adresse email",
        phone_name: "Téléphone",
        email_address: "Adresse email",
        password: "mot de passe",
        country: "pays",
        select_country: "Choisissez un pays",
        cancel: "Annuler",
        confirm: "Bien sûr",
        please_enter: "Veuillez saisir 6-20 caractères (combinaison de lettres, de chiffres ou de symboles)",
        select_country_tips: "La sélection du pays est pour la visualisation des forfaits locaux. Il ne peut pas être modifié après l'inscription. Veuillez confirmer!",
        global_roaming: "Code du domaine international",
        phone_number: "numéro de téléphone",
        agree: "accepter",
        user_agreement: "Contrat d'utilisateur",
        and: "et",
        privacy_policy: "politique de confidentialité",
        register_login: "Inscrivez-vous ou connectez-vous",
        login_error: "Le nombre de connexions est trop fréquent, veuillez réessayer plus tard!",
        register_error: "Le nombre d'inscriptions est trop fréquent, veuillez réessayer plus tard!",
        forgot_pwd: "Oubliez le mot de passe",
        app_tips: "Connectez-vous à l'application avec ce compte après l'avoir téléchargé pour accéder à plus de fonctionnalités.",
        download_app: "Allez télécharger l'application",
        rememberPwd: "se souvenir du mot de passe",
        third_login: 'Continuez avec',
        agreement_tips: "Veuillez cocher la case Contrat d'utilisation et Politique de confidentialité",
        selectCountry_tips: "Veuillez noter que le pays enregistré affectera directement les méthodes de paiement et les devises suivantes, veuillez sélectionner en fonction de vos besoins.",
        login_error_cancel: "L'utilisateur a annulé la connexion",
        login_error_auth: "Autorisez les pop-ups dans les paramètres du navigateur",
        device_tips: "Appareil en attente d'activation. Traitement sous 24h."
      },
      forgotPwd: {
        forgot_pwd: "Oubliez le mot de passe",
        email_address: "Adresse email",
        next: "Suivant",
        email_has_been_sent: "Nous avons envoyé un e-mail à %@email. Veuillez cliquer sur le lien et suivre les étapes pour récupérer votre mot de passe.",
        have_retrieved_it: "Je l'ai trouvé",
        unable_to_receive_email: "Vous ne pouvez pas recevoir l'e-mail? Veuillez vérifier s'il y a des e-mails de %@email sous votre spam et le répertoire du courrier supprimé",
        or: "ou",
        resend: "Revivre",
        global_roaming: "Code du domaine international",
        phone_number: "numéro de téléphone",
        verification_code_has_been_sent: "Nous avons envoyé le code de vérification à:",
        verification_code: "Le code de vérification",
        no_verification_code_received: "Vous n'avez pas reçu le code de vérification?",
        please_enter: "Veuillez saisir 6-20 caractères (combinaison de lettres, de chiffres ou de symboles)",
        reset_password: "Réinitialiser le mot de passe",
        reset_successful: "Réinitialiser avec succès"
      },
      coupons: {
        coupons_name: "Coupons",
        no_coupons: "Pas encore de coupons",
        no_data: "Pas encore de données",
        applicable_to_the_following: "Les coupons conviennent au package de données suivant"
      },
      digital: {
        title: "Appareil Sn",
        purchased: "Mes achats",
        viewAll: "Plus",
        skinStore: "Magasin de produits",
        completed: "Acheté",
        goBuy: "Acheter",
        order: {
            title: "Commandes achetées"
        },
        detail: {
            describe: "Description"
        }
      },
      viewPL: {
        other: 'autres'
      },
      invalidFlow: {
        stateName: 'Statut',
        state: {
          NOT_ACTIVATED: "Inactivé",
          IN_USING: "Disponible",
          USE_END: "Épuisé",
          EXPIRE: "Expiré",
          TRANSFER: "Transfert",
          UNSUBSCRIBE: "Annuler",
          VALID: "Valide",
          INVALID: "Invalide",
          EXCHANGE_POINTS: "Échanger des points"
        },
        noneFlow: 'Aucun forfait de données expiré',
        pageName: 'Forfait de données expiré'
      },
      flowDetail: {
        title: 'Détails des données',
        flow: 'Données',
        validTime: 'Détails des données',
        invalidTime: 'Valable jusqu\'au',
        coverage: 'Couverture',
        useIntro: 'Termes et conditions',
        purchaseTime: 'Acheté à',
        subtotal: 'Total',
        status: 'Statut',
        cancel: 'Annuler',
        buyAgain: 'Achetez-le à nouveau',
        validity: 'Validité',
        tip: 'Avis', 
        cancelTip: 'Êtes-vous sûr de vouloir rembourser ce forfait ?',
        dataLeft: 'Données restantes'
      },
      netError: {
        try_again: 'Essayer à nouveau',
        net_error: 'Pas de réseau',
        try_again_desc: 'Veuillez vérifier les paramètres réseau et réessayer'
      },
      loadFail: {
        try_again: 'Essayer à nouveau',
        load_fail: 'Le chargement a échoué',
        load_fail_desc: 'Échec du chargement des données, veuillez réessayer',
        IMEI_Not_Exist: 'IMEI n\'existe pas, veuillez essayer d\'entrer par la bonne entrée',
        Project_Not_Exist:'Une erreur se produit. Veuillez contacter le service client.(01)',
        commonError:'Une erreur se produit. Veuillez contacter le service client.',
      },
      settlement_Easy_and_convenient:"Facile et pratique",
      settlement_Great_deal:"Très bien",
      settlement_Safe_and_secure:"Sûr et sécurisé",
      settlement_Autopay_service_regulation:"Règlement sur les services automatique",
      settlement_Read:"Lire",
      settlement_No_coupon:"Aucun coupon disponible",
      settlement_Subtotal:"Total",
      settlement_Coupon:"Coupon",
      settlement_TOTAL:"Total",
      settlement_promotion_tip:"L'offre promotionnelle ne peut pas être utilisée en conjonction avec des coupons",
      settlement_coupon_tip:"Le coupon ne peut être utilisé en conjonction avec d'autres offres promotionnelles",
      member_myFlow_noList:"Pas de données",
      detail_se_content:"Une manière sécurisée, facile et pratique. Vous pouvez vous désinscrire à tout moment",
      Enter_Promo_code:"Code de promotion",
      Enter_Promo_Coupon:"Coupons",
      settlement_Not_used_coupon:"coupon non utilisé",
      settlement_Available_coupon:"Disponible",
      settlement_Unavailable_coupon:"Indisponible",
      please_Enter_Promo_code:"Veuillez saisir le code de promotion",
      please_Select_Coupon_use:　"Veuillez sélectionner le coupon que vous souhaitez utiliser.",
      Buy_Now:"Acheter maintenant",
      Dont_Use_Any:"N'utilisez aucun",
      settlement_confirm:"Confirmer",
      flowDetail_unsubscribe: "Se désabonner",
      flowDetail_unsubscribed: "Non abonné",
      flowDetail_isCancelPackage: "Débranchez ce package?",
      flowDetail_confirmAgreementUnsubscribe : "Vous ne pouvez pas avoir la grande affaire après vous désinscrire. Êtes-vous sûr de vouloir vous désabonner?",
      flowDetail_cancel: "Annuler",
      flowDetail_cancelSuccess: "Se désinscrire avec succès",
      packages_detail_promotion:"Promotion",
      orderTips:{
        "iDay" : "jour",
        "iDays" : "jours",
        "iMonth" : "mois",
        "iMonths" : "mois",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Lors de votre premier achat, payer %@money/%@periodSymbol plus tard, Vous pouvez vous désinscrire à tout moment",
        'Monthly_discount':"Économisez %@saveMoney chaque %@period! Vous pouvez vous désinscrire à tout moment ",
        'Ordinary_monthly_package':"Une manière sécurisée, facile et pratique. Vous pouvez vous désinscrire à tout moment",
        "AlreadyPurchased":'Désolé que vous ne puissiez vous abonner à un seul package de données pour le moment. Veuillez vous désinscrire de “%@” et abonner plus tard à tout package que vous désirez après son expiration.',
        "Contract_recommendation_First":'<label>Avec le service automatique, lors de votre premier achat, payez uniquement</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Vous pouvez vous désinscrire à tout moment'
        +'<a class="btn">S\'abonner ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Avec le service automatique, payez uniquement</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Vous pouvez vous désinscrire à tout moment'
        +'<a class="btn">S\'abonner ></a></p>',
        "Contract_recommendation_General":"<label>Avec service automatique</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Une manière sécurisée, facile et pratique. Vous pouvez vous désinscrire à tout moment'
        +'<a href="javascript:;" class="btn">S\'abonner ></a></p>',
        'BanlanceDoubleCheck':'Êtes-vous sûr de vouloir payer avec le solde?',
    },
    feedback: {
      title: "retour",
      placeholder: "Veuillez entrer dans le pays que vous souhaitez visiter ou toute autre question, et nous répondrons à vos besoins dès que possible!",
      submit: "Soumettre",
      submit_success: "Soumission réussie",
      other_opinions: "Autres avis"
    },
    view_country_input: 'Veuillez entrer votre compte',
    select_package: {
      title: 'Choisir les données',
      allPackage: 'Toutes les Données',
      type: 'Type',
      flow: 'Données',
      month_package: 'Forfait Mensuel',
      flow_package: 'Forfait Données',
      time: 'Durée',
      period: 'Cycle',
      auto_debit: 'Info Prélèvement Auto',
      auto_subscribe: 'Auto-Renouvellement',
      detail: 'Détails des Données',
      carrier: 'Opérateurs pris en charge',
      country: 'Pays Couverts',
      notice: 'Guide d\'Achat'
    }
}